<div class="outer-container" *ngIf="isAccountGreaterThanOne">
    <div class="d-flex flex-wrap flex-row justify-content-center align-items-center"  style="gap: 0.5%;">
        <div class="reset-pwd-panel">
            <div class="d-flex flex-row">
                <div  class="header-content w-100">
                    <div class="main-logo">
                        <a [attr.href]="isEnactEmail ? companyWebUrl : null" target="_blank">
                            <img [src]="companyLogo" class="companyLogo" alt="logo">
                        </a>
                    </div>
                    <div class="subhead">
                        <div class="rightHead">
                            <a [href]="needSupportEmail">
                                <img src="assets/images/login/Help.svg" class="input-img" alt="">
                                <div class="support-txt">{{'account.needSupport' | translate }}?</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div> 

            <form class="resetPwdForm1" [formGroup]="accountsForm" name="updateCognitoPwdForm"
                (ngSubmit)="onSelectAcc()">

                <div class="d-flex flex-row">
                    <div  class="header-div w-100">
                        <div class="sign-in">{{'account.yourAccnt' | translate }}</div>
                        <div class="welcom-div">{{'account.lookLikesMultipleAcc' | translate }}</div>
                    </div>
                </div>
                <div class="lower-content">
                    <div class="marginTop">
                        <label for="email" class="select-dd">{{'account.selectAnAcc' | translate }}</label>
                        <div class="form-group form-cust">
                            <mat-form-field appearance="outline" >
                                <mat-select [disableOptionCentering]="true" #select1  placeholder="{{'selAcc' | translate }}" formControlName="accountId"  panelClass="testClass"
                                [ngClass]="{ 'is-invalid': submittedAcc && ac.accountId.errors }" (selectionChange)="onAccountChange($event)">
                                    <mat-form-field class="search-field" *ngIf="select1.panelOpen">
                                        <!-- <mat-label>{{'buttons.search' | translate }}</mat-label> -->
                                        <input matInput [value]="accountSearchFilter"  placeholder="{{'buttons.search' | translate }}"  (input)="onFilterChange($event)" placeholder="{{'buttons.search' | translate }}">
                                    </mat-form-field>
                                    <mat-option value="">{{'account.selectAcc' | translate }}</mat-option>
                                    <mat-option *ngFor="let item of allAccountsVars" [value]="item">
                                        {{item.account_id}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- Test: Show error if errors exist and touched -->
                            <div *ngIf="ac.accountId?.errors && ac.accountId?.touched" class="invalid-feedback">
                                <span *ngIf="ac.accountId.errors?.required">{{'project.inputValid.fieldsMandatory' | translate }}</span>
                            </div>
                            
                        </div>
                    </div>

                    <div class="form-group loginBtnWrapper">
                        <button type="submit" class="full-login-ct" color="primary" [disabled]="!accountsForm.get('accountId')?.value?.account_id?.trim()"
                        [class.enablebtn]="accountsForm.get('accountId')?.value?.account_id?.trim()">
                            <img src="assets/images/login/right-arrow.svg" class="input-img-ct" alt="" >
                            {{'account.continue' | translate }}
                        </button>

                        <button type="button" class="back-sign-in" color="primary" (click)="backTosignIn()">
                            {{'account.backToSignIn' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>